import React, { useCallback } from 'react';

import { Card, CardActionArea, Typography, Chip } from '@material-ui/core';
import { ChevronIcon, AgencyIcon } from 'components/Icons';

import { AssociadoRoutePath } from 'library/Routes';

import { history } from 'store/Store';

import moment from 'moment';

import { useStyles } from './styles';
interface ICardProps {
  idEvento: string;
  nome: string;
  tipo: string;
  date: string;
  coop: string;
}
const CartaoEvento = ({ tipo, nome, date, coop, idEvento }: ICardProps) => {
  const classes = useStyles();
  const handleClick = useCallback(() => {
    history.push(`${AssociadoRoutePath}/assembleia/${idEvento}/`);
  }, [idEvento]);

  return (
    <Card className={classes.root}>
      <CardActionArea onClick={handleClick} className={classes.clickArea}>
        <ChevronIcon className={classes.iconChevron} />
        <hgroup className={classes.titleGroup}>
          <Typography component='h1' className={classes.tipo}>
            {tipo}
          </Typography>
          <Typography component='h2' className={classes.nome}>
            {idEvento} - {nome}
          </Typography>
        </hgroup>
        {typeof date === 'string' && (
          <React.Fragment>
            <Typography component='h1' className={classes.titleData}>
              Data
            </Typography>
            <Typography component='h1' className={classes.currentData}>
              {moment(date).format('DD/MM/YYYY - HH:mm')}
            </Typography>
          </React.Fragment>
        )}
        <Chip icon={<AgencyIcon />} label={coop} className={classes.chipCoop} />
      </CardActionArea>
    </Card>
  );
};

export default CartaoEvento;
